import React from 'react';
import {
  Col,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

export const ActionMenu = () => {
  return (
    <Col sm={12}>
      <div className='border-top border-top-dashed'>
        <Row>
          <Col sm={12}>
            <UncontrolledDropdown className='float-end'>
              <DropdownToggle tag='a' className='btn btn-soft-secondary btn-sm'>
                <i className='ri-more-fill align-middle'></i>
              </DropdownToggle>
              <DropdownMenu className='dropdown-menu-end'>
                <li>
                  <DropdownItem href='/apps-tickets-details'>
                    <i className='ri-eye-fill align-bottom me-2 text-muted'></i>{' '}
                    View
                  </DropdownItem>
                </li>
                <li>
                  <DropdownItem
                    className='edit-item-btn'
                    href='#showModal'
                    data-bs-toggle='modal'
                    onClick={() => {
                      const TicketData = cell.row.original;
                      handleTicketsClick(TicketData);
                    }}
                  >
                    <i className='ri-pencil-fill align-bottom me-2 text-muted'></i>{' '}
                    Edit
                  </DropdownItem>
                </li>

                {/* <li>
                                    <DropdownItem className="remove-item-btn" data-bs-toggle="modal" href="#deleteOrder"
                                        onClick={() => {
                                            const ticketData = cell.row.original;
                                            onClickDelete(ticketData);
                                        }}>
                                        <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Delete
                                    </DropdownItem>
                                </li> */}
              </DropdownMenu>
            </UncontrolledDropdown>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default ActionMenu;
